import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";

const MultiInputTagText = ({
  label,
  length,
  name,
  nameDefaultValue,
  defaultValue,
  type,
  required,
  textArea,
}) => {
  const [visibility, setVisibility] = useState(true);

  const handleDelete = (event) => {
    setVisibility(false);
  };

  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end" : "gap-1 items-end hidden"}
    >
      <div className="w-full">
        <label className="label">
          <span className="text-md font-semibold">
            {length ? label + " " + length : label}
          </span>
        </label>
        <label className="input-group">
          <input
            name={visibility ? nameDefaultValue : ""}
            defaultValue={nameDefaultValue}
            type={type}
            className="input input-bordered w-full z-0"
            required={required}
          />
          {textArea ? (
            <textarea
              row={1}
              name={visibility ? name : ""}
              defaultValue={defaultValue}
              type="Text"
              className="textarea textarea-bordered h-12 w-full"
            />
          ) : (
            <input
              name={visibility ? name : ""}
              defaultValue={defaultValue}
              type={type}
              className="input input-bordered w-full z-0"
              required={required}
            />
          )}
        </label>
      </div>
      <div>
        <button
          type="button"
          onClick={handleDelete}
          className="btn  btn-sm btn-circle"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default MultiInputTagText;
